import { InjectionToken } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

export const ComponentType = new InjectionToken<ThemeComponent>('component type')
